import React, { useEffect, memo, useState } from 'react';
import { View, ScrollView } from 'react-native';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import _ from 'lodash';
import { useHistory, useLocation, useParams } from '../../../services/router';
import Title from '../../../components/Content/Title';
import styles from './styles';
import BoxInfosControl from '../../../components/BoxInfosControl';
import SubTitle from '../../../components/Content/SubTitle';
import { t } from '../../../services/i18n';
import { makeSelectLocations } from '../../../providers/LocationsProvider/selectors';
import HtmlParser from '../../../components/HtmlParser';
import decodeCMSEncoding from '../../../utils/decodeCMSEncoding';
import API from '../../../config/api';
import { makeSelectButtons } from '../../../providers/ButtonsProvider/selectors';
import { loadButtons } from '../../../providers/ButtonsProvider/actions';
import Button from '../../../components/Button';
import ImageSecured from '../../ImageSecured';
import PinButton from '../../../components/PinButton';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { Image } from 'react-native';
import login from '../../../services/login';

function LocationHome({ locations, buttons, handleLoadButtons }) {
	const [pinButtons, setPinButtons] = useState([]);
	const [analyticsEnable, setAnalyticsEnable] = useState(false);
	const location = useLocation();
	const history = useHistory();
	const { locationId } = useParams();
	const currentLocation = locations.find((el) => el.id === locationId);
	const field3 = JSON.parse(currentLocation?.field3);
	const field11 = JSON.parse(decodeCMSEncoding(currentLocation.field11 || '[]'));
	const field14 = JSON.parse(currentLocation.field14);
	const field21 = currentLocation.field21;
	const field22 = currentLocation.field22;
	const informations = field3 ? field3.information : [];

	const haveContacts = !(field11 === null || field11.length === 0);
	const haveOverview = !(field14 === null || field14.length === 0);

	const indexCompliance = _.findIndex(buttons, ({ field15, field2 }) => field15 === currentLocation.id && field2.toUpperCase() === 'COMPLIANCE');
	const indexDailyShiftReport = _.findIndex(buttons, ({ field15, field2 }) => field15 === currentLocation.id && field2.toUpperCase() === 'DAILY SHIFT REPORT');
	const indexAnalyticsReport = _.findIndex(buttons, ({ field15, field2 }) => field15 === currentLocation.id && field2.toLowerCase().includes('analytic'));
	//console.log(currentLocation, "indexDailyShiftReport02");


	const getPin = async (newPinButtons) => {
		const getPinButtons = newPinButtons ? newPinButtons : await AsyncStorage.getItem('pinButtons');
		const pinBtns = getPinButtons ? JSON.parse(getPinButtons) : [];
		setPinButtons(pinBtns);
	};
	useEffect(() => {
		getPin();
		checkAnalytics();
	}, []);


	const checkAnalytics = async () => {
		const user = await login.getUser();
		console.log(user, "user");

		const addInfo21 = user.addInfo21;
    const addInfo1 = user.addInfo1;
		if ((field21 === 'true') && (field22 === 'true' || addInfo21 === 'true')  && (addInfo1 == '1' || addInfo1 == '8' || addInfo1=='6')) {
			setAnalyticsEnable(true)
		}
	};

	const firstLevelButtons = [];
	buttons.forEach((button) => {
		const hasParentButton = button?.field8 ? buttons.find((b) => Number(b.id) === Number(button.field8)) : false;
		if (button.field15 === locationId && !hasParentButton) {
			firstLevelButtons.push(button);
		}
	});

	firstLevelButtons.sort((a, b) => Number(a.field14) - Number(b.field14));

	useEffect(() => {
		handleLoadButtons(currentLocation);
	}, [locationId]);
	return (
		<ScrollView contentContainerStyle={styles.scrollInner}>
			<View style={styles.container}>
				<Title title={currentLocation?.field2 || currentLocation?.id} />
				<View pose="enter" initialPose="exit" style={styles.boxInfos}>
					{/* {haveContacts && (
						<View style={styles.boxInfo}>
							<BoxInfosControl
								to={`${location.pathname}/contact`}
								type="Feather"
								icon="users"
								title={t('Contact')}
							/>
						</View>
					)}
					{indexDailyShiftReport !== -1 && (
						<View style={styles.boxInfo}>
							<BoxInfosControl
								to={`${location.pathname}/DailyShiftReportHistory/${buttons[indexDailyShiftReport]?.id}`}
								// to={`${location.pathname}/dailyShiftReport/${buttons[indexDailyShiftReport].id}`}
								type="Entypo"
								icon="open-book"
								title={t('DailyShiftReport')}
							/>
						</View>
					)}
					{indexCompliance !== -1 && (
						<View initialPose="exit" pose="enter" style={styles.boxInfo}>
							<BoxInfosControl
								to={`${location.pathname}/button/${buttons[indexCompliance].id}`}
								type="Feather"
								icon="check-square"
								title={t('Compliance')}
							/>
						</View>
					)} */}

					{analyticsEnable && (
						<View style={styles.boxInfo}>
							<BoxInfosControl
								to={`${location.pathname}/analytics`}
								type="Ionicons"
								icon="bar-chart-outline"
								title={t('Analytics')}
							/>
						</View>
					)}
					{firstLevelButtons && firstLevelButtons?.length > 0 && firstLevelButtons?.filter(item => pinButtons?.includes(item.id)).map((button, index) => (
						<View style={styles.boxInfo}>
							<PinButton
								key={button.id}
								content={decodeCMSEncoding(button?.field2)}
								locationId={locationId}
								type={button.field6}
								buttonId={button.id}
							/>
						</View>
					))}
				</View>
				{/* {haveOverview && (
					<>
						{field14.map((info) => (
							<React.Fragment key={info.title}>
								<SubTitle title={info.type || ''} />
								<HtmlParser html={info.description} />
							</React.Fragment>
						))}
					</>
				)} */}
				{informations.map((info) => (
					<React.Fragment key={info.title}>
						<SubTitle title={info.type || ''} />
						<HtmlParser html={info.description} />
					</React.Fragment>
				))}
				{(typeof currentLocation?.field20 === 'string' && currentLocation?.field20 !== '') && (
					<View style={styles.imageContainer}>
						<Image
							resizeMode="contain"
							style={[styles.imageWeb]}
							source={{ uri: `https://sb-all-images-data.s3.ca-central-1.amazonaws.com/${currentLocation.field20}` }}
						/>
						{/* <ImageSecured
							progressiveRenderingEnabled
							style={styles.imageWeb}
							resizeMode="contain"
							id={currentLocation.field20}
							source={{ uri: `https://sb-all-images-data.s3.ca-central-1.amazonaws.com/${currentLocation.field20}` }}
						/> */}
					</View>
				)}
				{firstLevelButtons.length > 0 && (
					<>
						<SubTitle title="Buttons" />
						{firstLevelButtons.map((button) => (
							<Button
								key={button.id}
								content={decodeCMSEncoding(button.field2)}
								locationId={locationId}
								type={button.field6}
								buttonId={button.id}
								onPinPress={(newPinButtons) => { getPin(newPinButtons); }}
							/>
						))}
					</>
				)}
			</View>
		</ScrollView>
	);
}

const mapStateToProps = createStructuredSelector({
	locations: makeSelectLocations(),
	buttons: makeSelectButtons(),
});

export function mapDispatchToProps(dispatch) {
	return {
		dispatch,
		handleLoadButtons: (location) => dispatch(loadButtons(location)),
	};
}

const withConnect = connect(
	mapStateToProps,
	mapDispatchToProps,
);

export default compose(
	withConnect,
	memo,
)(LocationHome);
